"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var U=require("react"),u=require("@vfuk/core-base-props"),c=require("@vfuk/core-icon"),N=require("@vfuk/core-themes"),m=require("@vfuk/core-loading-spinner"),a=require("styled-components"),W=require("@vfuk/core-interaction"),n=require("@vfuk/core-mixins");function i(e){return e&&e.__esModule?e:{default:e}}var l=i(U),F=i(c),G=i(m),s=i(a),H=i(W),J=Object.defineProperty,y=Object.getOwnPropertySymbols,K=Object.prototype.hasOwnProperty,Q=Object.prototype.propertyIsEnumerable,$=(e,o,r)=>o in e?J(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,V=(e,o)=>{for(var r in o||(o={}))K.call(o,r)&&$(e,r,o[r]);if(y)for(var r of y(o))Q.call(o,r)&&$(e,r,o[r]);return e};const k=e=>{const o={backgroundColor:e.color.success.default,iconColor:e.color.monochrome1.default,border:"transparent",hover:{backgroundColor:e.color.success.hover,iconColor:e.color.monochrome1.default,border:"transparent"},pressed:{backgroundColor:e.color.success.pressed,iconColor:e.color.monochrome1.default,border:"transparent"},inverse:{backgroundColor:e.inverseColor.success.default,iconColor:e.color.monochrome1.default,border:"transparent",hover:{backgroundColor:e.inverseColor.success.hover,iconColor:e.color.monochrome1.default,border:"transparent"},pressed:{backgroundColor:e.inverseColor.success.pressed,iconColor:e.color.monochrome1.default,border:"transparent"}}},r={success:o,selected:o};return{appearance:{primary:{backgroundColor:e.color.primary1.default,iconColor:e.color.monochrome1.default,border:"transparent",iconAppearance:"primary",loadingSpinnerAppearance:"primary",inverseIcon:!0,hover:{backgroundColor:e.color.primary1.hover,iconColor:e.color.monochrome1.default,border:"transparent"},pressed:{backgroundColor:e.color.primary1.pressed,iconColor:e.color.monochrome1.default,border:"transparent"},inverse:{backgroundColor:e.inverseColor.primary1.default,iconColor:e.inverseColor.monochrome6.default,border:"transparent",iconAppearance:"primary",inverseIcon:!0,hover:{backgroundColor:e.inverseColor.primary1.hover,iconColor:e.inverseColor.monochrome6.default,border:"transparent"},pressed:{backgroundColor:e.inverseColor.primary1.pressed,iconColor:e.inverseColor.monochrome6.default,border:"transparent"}}},secondary:{backgroundColor:e.color.monochrome6.default,iconColor:e.color.monochrome1.default,border:"transparent",iconAppearance:"primary",loadingSpinnerAppearance:"primary",inverseIcon:!0,hover:{backgroundColor:e.color.monochrome6.hover,iconColor:e.color.monochrome1.default,border:"transparent"},pressed:{backgroundColor:e.color.monochrome6.pressed,iconColor:e.color.monochrome1.default,border:"transparent"},inverse:{backgroundColor:e.inverseColor.monochrome6.default,iconColor:e.inverseColor.monochrome1.default,border:"transparent",iconAppearance:"primary",inverseIcon:!1,hover:{backgroundColor:e.inverseColor.monochrome6.hover,iconColor:e.inverseColor.monochrome1.default,border:"transparent"},pressed:{backgroundColor:e.inverseColor.monochrome6.pressed,iconColor:e.inverseColor.monochrome1.default,border:"transparent"}}},alt1:{backgroundColor:e.color.monochrome1.default,iconColor:e.color.monochrome6.default,border:e.color.monochrome6.default,iconAppearance:"primary",loadingSpinnerAppearance:"primary",inverseIcon:!1,hover:{backgroundColor:e.color.monochrome6.hover,iconColor:e.color.monochrome1.default,border:e.color.monochrome6.hover},pressed:{backgroundColor:e.color.monochrome6.pressed,iconColor:e.color.monochrome1.default,border:e.color.monochrome6.pressed},inverse:{backgroundColor:e.inverseColor.monochrome1.default,iconColor:e.inverseColor.monochrome6.default,border:e.inverseColor.monochrome6.default,inverseIcon:!0,hover:{backgroundColor:e.inverseColor.monochrome6.hover,iconColor:e.inverseColor.monochrome1.default,border:e.inverseColor.monochrome6.hover},pressed:{backgroundColor:e.inverseColor.monochrome6.pressed,iconColor:e.inverseColor.monochrome1.default,border:e.inverseColor.monochrome6.pressed}}},alt2:{backgroundColor:e.color.monochrome1.default,iconColor:e.color.monochrome6.default,border:e.color.primary1.default,iconAppearance:"primary",loadingSpinnerAppearance:"primary",inverseIcon:!1,hover:{backgroundColor:e.color.primary1.hover,iconColor:e.color.monochrome1.default,border:e.color.primary1.hover},pressed:{backgroundColor:e.color.primary1.pressed,iconColor:e.color.monochrome1.default,border:e.color.primary1.pressed},inverse:{backgroundColor:e.inverseColor.monochrome1.default,iconColor:e.inverseColor.monochrome6.default,border:e.inverseColor.primary1.default,inverseIcon:!0,hover:{backgroundColor:e.inverseColor.primary1.hover,iconColor:e.inverseColor.monochrome6.default,border:e.inverseColor.primary1.hover},pressed:{backgroundColor:e.inverseColor.primary1.pressed,iconColor:e.inverseColor.monochrome6.default,border:e.inverseColor.primary1.pressed}}}},state:V({},r),size:{1:{iconSize:1,loadingSpinnerSize:1,sm:{buttonSize:24},md:{buttonSize:24}},2:{iconSize:2,loadingSpinnerSize:2,sm:{buttonSize:32},md:{buttonSize:32}},3:{iconSize:2,loadingSpinnerSize:2,sm:{buttonSize:36},md:{buttonSize:36}},4:{iconSize:3,loadingSpinnerSize:3,sm:{buttonSize:44},md:{buttonSize:44}},5:{iconSize:3,loadingSpinnerSize:3,sm:{buttonSize:48},md:{buttonSize:48}},6:{iconSize:4,loadingSpinnerSize:4,sm:{buttonSize:56},md:{buttonSize:60}}}}},z=typeof s.default=="object"&&"default"in s.default?s.default.default:s.default,T=z(H.default)(e=>a.css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    position: relative;
    height: ${e.iconButtonTheme.size[e.size].sm.buttonSize}px;
    width: ${e.iconButtonTheme.size[e.size].sm.buttonSize}px;
    border-radius: ${e.theme.border.radius[2]};
    font-weight: ${e.theme.fontWeight[2]};
    background: ${e.iconButtonTheme.appearance[e.appearance].backgroundColor};
    border: ${e.theme.border.width[2]} ${e.theme.border.style[1]} ${e.iconButtonTheme.appearance[e.appearance].border};

    ${c.IconStyles.Icon} {
      * {
        ${n.iconAppearance(e.iconButtonTheme.appearance[e.appearance].iconColor)};
      }
    }

    &:active {
      background: ${e.iconButtonTheme.appearance[e.appearance].pressed.backgroundColor};
      border-color: ${e.iconButtonTheme.appearance[e.appearance].pressed.border};

      ${c.IconStyles.Icon} {
        * {
          ${n.iconAppearance(e.iconButtonTheme.appearance[e.appearance].pressed.iconColor)};
        }
      }
    }

    &:hover {
      background: ${e.iconButtonTheme.appearance[e.appearance].hover.backgroundColor};
      border: ${e.theme.border.width[2]} ${e.theme.border.style[1]}
        ${e.iconButtonTheme.appearance[e.appearance].hover.border};

      ${c.IconStyles.Icon} {
        * {
          ${n.iconAppearance(e.iconButtonTheme.appearance[e.appearance].hover.iconColor)};
        }
      }

      ${m.LoadingSpinnerStyles.LoadingSpinner} {
        svg {
          & > * {
            stroke: ${e.iconButtonTheme.appearance[e.appearance].hover.iconColor};
          }
        }
      }
    }

    ${n.respondTo.md(a.css`
      height: ${e.iconButtonTheme.size[e.size].md.buttonSize}px;
      width: ${e.iconButtonTheme.size[e.size].md.buttonSize}px;
    `)}

    ${e.inverse&&a.css`
      background: ${e.iconButtonTheme.appearance[e.appearance].inverse.backgroundColor};
      border: ${e.theme.border.width[2]} ${e.theme.border.style[1]}
        ${e.iconButtonTheme.appearance[e.appearance].inverse.border};

      &:hover {
        background: ${e.iconButtonTheme.appearance[e.appearance].inverse.hover.backgroundColor};
        border: ${e.theme.border.width[2]} ${e.theme.border.style[1]}
          ${e.iconButtonTheme.appearance[e.appearance].inverse.hover.border};

        ${c.IconStyles.Icon} {
          * {
            ${n.iconAppearance(e.iconButtonTheme.appearance[e.appearance].inverse.hover.iconColor)};
          }
        }

        ${m.LoadingSpinnerStyles.LoadingSpinner} {
          svg {
            & > * {
              stroke: ${e.iconButtonTheme.appearance[e.appearance].inverse.hover.iconColor};
            }
          }
        }
      }

      ${c.IconStyles.Icon} {
        * {
          ${n.iconAppearance(e.iconButtonTheme.appearance[e.appearance].inverse.iconColor)};
        }
      }

      &:active {
        background: ${e.iconButtonTheme.appearance[e.appearance].inverse.pressed.backgroundColor};
        border-color: ${e.iconButtonTheme.appearance[e.appearance].inverse.pressed.border};

        ${c.IconStyles.Icon} {
          * {
            ${n.iconAppearance(e.iconButtonTheme.appearance[e.appearance].inverse.pressed.iconColor)};
          }
        }
      }
    `}

  ${e.shape==="circle"&&a.css`
      border-radius: 50%;
    `}

  ${e.state&&a.css`
      ${e.state==="disabled"&&a.css`
        ${n.opacity(!0)};
        cursor: not-allowed;
      `}

      ${e.state!=="disabled"&&a.css`
        background: ${e.iconButtonTheme.state[e.state].backgroundColor};

        &:hover {
          background: ${e.iconButtonTheme.state[e.state].hover.backgroundColor};

          ${c.IconStyles.Icon} {
            * {
              ${n.iconAppearance(e.iconButtonTheme.state[e.state].iconColor)};
            }
          }
        }
      `}
    `}
  `),B=z.span(()=>a.css`
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0px;
    right: 0px;
    display: flex;
    justify-content: center;
  `);var X=Object.freeze({__proto__:null,IconButton:T,LoadingIcon:B});const I=({shape:e="square",size:o=6,appearance:r="primary",htmlAttributes:h={},dataAttributes:A,dataSelectorPrefix:d,localTheme:_,state:b,loading:v,href:x,inverse:C,onClick:w,onMouseDown:P,onMouseUp:j,onTouchStart:q,onTouchEnd:D,srText:M,id:O,customRouterProps:E,icon:f})=>{const g="IconButton",t=N.useLocalTheme(g,k,_);let p=t.appearance[r];C&&(p=p.inverse);const{loadingSpinnerAppearance:L,inverseIcon:R}=p,S=b==="disabled"||v;return l.default.createElement(T,{appearance:r,target:h.target,type:h.type,componentName:g,dataAttributes:A,size:o,shape:e,inverse:C,state:b,onClick:w,onMouseDown:P,onMouseUp:j,onTouchStart:q,onTouchEnd:D,disabled:S,label:M,href:S?void 0:x,id:O,customRouterProps:E,iconButtonTheme:t,dataSelectorPrefix:u.getDataSelector(d),localTheme:t},v?l.default.createElement(B,null,l.default.createElement(G.default,{appearance:L,inverse:R,size:t.size[o].loadingSpinnerSize,dataSelectorPrefix:u.getDataSelector(d,"loading-spinner")})):l.default.createElement(F.default,{name:f.name,size:t.size[o].iconSize,dataSelectorPrefix:u.getDataSelector(d,f.name)}))};exports.IconButton=I;exports.IconButtonStyles=X;exports.default=I;exports.iconButtonTheme=k;
//# sourceMappingURL=index.cjs.map
